import { ScenarioResponse } from "@opstel/gen/knop/ui/v1/api/scenario_pb";
import { DateTime } from "luxon";
import { PlainMessage, Timestamp } from "@bufbuild/protobuf";
import { createSchema, ZodOutputFor } from "../zod-utils";
import z from "zod/v3";

export interface Scenario {
  instanceId: string;
  location: string;
  isSolvedByHip: boolean;
  scenarioStart: DateTime<true>;
  scenarioEnd: DateTime<true>;
}

export const scenarioSchema = createSchema<Scenario, PlainMessage<ScenarioResponse>>({
  instanceId: z.string().min(1, { message: "Scenario instanceId should not be empty" }),
  location: z.string().min(1, { message: "Scenario location should not be empty" }),
  isSolvedByHip: z.boolean(),
  scenarioStart: z
    .instanceof(Timestamp, { message: "Scenario start should not be empty" })
    .refine((timestamp) => timestamp)
    .transform((val) => DateTime.fromJSDate(val.toDate()))
    .refine((v) => v.isValid),
  scenarioEnd: z
    .instanceof(Timestamp, { message: "Scenario end should not be empty" })
    .refine((timestamp) => timestamp)
    .transform((val) => DateTime.fromJSDate(val.toDate()))
    .refine((v) => v.isValid),
}) satisfies ZodOutputFor<Scenario>;
